import { toast } from "sonner";

export function notifySuccess(message) {
  toast.success(message);
}

export function notifyError(message) {
  if (message == null || message === "") return;
  const text = String(message);
  const lines = text
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);
  if (lines.length > 1) {
    toast.error(lines[0], { description: lines.slice(1).join("\n") });
    return;
  }
  toast.error(text);
}
